import { c as _c } from "react/compiler-runtime";
import type { IdType } from '@/components/Molecules/BVideoPlayer/BVideoPlayer';
import { buildEmbedOptions } from '@/components/Molecules/BVideoPlayer/BVideoPlayer';
import { ensureScript } from '@/utils/ensureScript';
import { useEffect, useRef } from 'react';
export const useBVideoPlayer = (targetNodeClass, t0) => {
  const $ = _c(6);
  const onFirstPlay = t0 === undefined ? null : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const players = useRef(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      for (const player of players.current as any[]) {
        if (player.dispose) {
          player.dispose();
        }
      }
      players.current = [];
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const clearPlayer = t2;
  let t3;
  if ($[2] !== onFirstPlay || $[3] !== targetNodeClass) {
    t3 = () => {
      const videoElements = Array.from(document.getElementsByClassName(targetNodeClass));
      if (videoElements.length === 0) {
        return;
      }
      ensureScript("https://assets.bwbx.io/s3/multimedia/projector/latest/bplayer.js").then(() => {
        if (!(window as any).BPlayer) {
          return;
        }
        clearPlayer();
        for (const [i, elem] of videoElements.entries()) {
          const videoId = (elem as HTMLElement).dataset.videoId;
          const videoIdType = (elem as HTMLElement).dataset.videoIdType;
          if (!videoId || !videoIdType || !elem.isConnected) {
            continue;
          }
          const embedOptions = buildEmbedOptions({
            videoId,
            videoIdType: videoIdType as IdType
          });
          const newDiv = document.createElement("div");
          elem.parentNode.replaceChild(newDiv, elem);
          const player_0 = (window as any).BPlayer.create(newDiv, embedOptions);
          players.current.push(player_0);
          if (onFirstPlay) {
            let isFirstPlay = true;
            player_0.on("play", () => {
              if (isFirstPlay) {
                isFirstPlay = false;
                onFirstPlay(videoId, i);
              }
            });
          }
        }
      }).catch(_temp);
      return clearPlayer;
    };
    $[2] = onFirstPlay;
    $[3] = targetNodeClass;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t3, t4);
};
function _temp(e) {
  console.warn(e.message);
}